import { render, staticRenderFns } from "./AssignInstance.vue?vue&type=template&id=624814cc&scoped=true&"
import script from "./AssignInstance.vue?vue&type=script&lang=js&"
export * from "./AssignInstance.vue?vue&type=script&lang=js&"
import style0 from "./AssignInstance.vue?vue&type=style&index=0&id=624814cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624814cc",
  null
  
)

export default component.exports